<template>
  <div class="main">
    <div class="name" :title="modelFileName" v-show="modelLoaded">
      <img src="./images/title.png" alt="图标">
      <span>{{modelFileName}}</span>
    </div>
    <!-- 小地图 -->
    <div class="minimaplevel" :style="{'left':marginLeft + 250 +'px'}" v-if="showminimaplevel">
      <el-select  v-model="mapdata" placeholder="请选择" size="mini" @change="setLevels">
        <el-option v-for="item in mapoptions" :key="item.id" :label="item.name" :value="item.elevation"></el-option>
      </el-select>
    </div>
    <modelView ref="modelView" :objData="obj"/>
    <Mbutton ref="Mbutton" :objData="obj"/>
    <Dbutton v-if="showdwg" ref="Dbutton" :objData="obj"/>
    <leftmeau ref="leftmeau" v-show="modelLoaded" :objData="obj"/>
    <setVue ref="modelSet" />
    <addModelNotation ref="addModelNotation" />
    <addDwgNotation ref="addDwgNotation" />
    <listNotation ref="listNotation" />
    <detailNotation ref="detailNotation" />
    <modelDwglist ref="modelDwglist" />
    <modelattr ref="modelattr" />
    <modeltree ref="modeltree" />
    <systemTree ref="systemTree" />
    <spaceTree ref="spaceTree" />
    <componentColor ref="componentColor" />
    <modelCompare ref="modelCompare" />
    <uploader ref="uploader" />
    <quaFlow ref="quaFlow" />
    <quaFlowList ref="quaFlowList" />
    <selectSet ref="selectSet" :objData="obj"/>
  </div>
</template>

<script>
import modelView from "./component/modelView.vue";
import Mbutton from "./component/Mbutton.vue";
import leftmeau from "./component/leftmeau.vue"
import setVue from "./component/set.vue";
import addModelNotation from "./component/addModelNotation.vue";
import addDwgNotation from "./component/addDwgNotation.vue";
import listNotation from "./component/listNotation.vue";
import detailNotation from "./component/detailNotation.vue";
import modelDwglist from "./component/modelDwglist.vue";
import Dbutton from "./component/Dbutton.vue";
import modelattr from "./component/modelattr.vue";
import modeltree from "./component/modeltree.vue"
import uploader from "@/CommonDP/components/UploaderForPerFileDan/Uploader";
import componentColor from "./component/componentColor.vue";
import modelCompare from "./component/modelCompare.vue";
import systemTree from "./component/systemTree.vue";
import spaceTree from "./component/spaceTree.vue";
import quaFlow from "./component/quaFlow.vue";//流程
import quaFlowList from "./component/quaFlowList.vue";//流程
import selectSet from "./component/selectSet.vue";//选择集
export default {
  props:{
    obj: {
      type: Object,
      required: false
    }, 
  },//这个参数是bim管理展示需要
  components:{
    modelView,Mbutton,leftmeau,setVue,addModelNotation,
    listNotation,detailNotation,modelDwglist,Dbutton,
    addDwgNotation,modelattr,modeltree,uploader,componentColor,
    modelCompare,systemTree,spaceTree,quaFlow,quaFlowList,selectSet
  },
  data(){
    return{
      modelLoaded:false,
      marginLeft: 0,//小地图左边距
      mapoptions: [],
      mapdata:'',
      showminimaplevel:false,
      showdwg:false,

    }
  },
  computed:{
    modelFileName(){
      return this.$route.query.fileNames ||this.obj.fileNames ||"未命名";
    }
  },
  created(){
    if (!navigator.userAgent.match(/x64/i)) {
      this.$message({
        message: "为了您更流畅的体验，建议您使用64位浏览器",
        type: "warning",
        duration: 2000,
      });
    }
  },
  methods:{
    getLevels(){
      if (!this.mapdata) {
        const levels = Monge.Model.getLevels();
        this.mapoptions = levels;
        this.mapdata = levels[0].elevation;
        this.setLevels();
      } else {
        this.setLevels();
      }
    },
    setLevels(){
      Monge.Model.MiniMap.deactive()
      Monge.Model.MiniMap.active({
        location: 'bottom',
        mapWidth: 400,
        mapHeight: 300,
        tools:{
          zoom:false,
          close:false
        },
        height: this.mapdata + 5,
        deactiveCB:(val,data)=>{
          // this.showminimaplevel = false
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.main{
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #fff;
  position: relative;
  .name{
    position: absolute;
    width: 285px;
    height: 40px;
    top: 0px;
    left: 56px;
    border-bottom-right-radius: 10px;
    background: rgba(255, 255, 255, 0.5);
    z-index: 2;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;
    img{
      width: 25px;
      height: 25px;
      object-fit: contain;
    }
    span{
      width: calc(100% - 25px);
      color: #fff;
      line-height: 40px;
      font-size: 14px;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
      text-indent: 3px;
      
    }
  }
}
.minimaplevel {
  width: 150px;
  position: absolute;
  left: 250px;
  bottom: 302px;
  z-index: 11;
  /deep/.el-select{
    background-color: rgba(0, 0, 0, 0.3) !important;
  }
}
</style>
